import { render, staticRenderFns } from "./starProduct.vue?vue&type=template&id=4aadb666&scoped=true"
import script from "./starProduct.vue?vue&type=script&lang=js"
export * from "./starProduct.vue?vue&type=script&lang=js"
import style0 from "./starProduct.vue?vue&type=style&index=0&id=4aadb666&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aadb666",
  null
  
)

export default component.exports